import { Dispatch, Fragment, SetStateAction, useCallback } from 'react';

import { Table } from 'CorePackage/TableModule/components/Table';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';
import { handleSortChange } from 'CorePackage/MainModule/common/handleSortChange';

import styles from './AgreementListTable.module.scss';
import { IAgreementRaw } from '../interfaces/IAgreementRaw';

interface IAgreementListTableProps {
  tableColumns: ITableColumn<IAgreementRaw>[];
  agreements: IAgreementRaw[];
  totalCount?: number;
  setTableColumns?: Dispatch<SetStateAction<ITableColumn<IAgreementRaw>[]>>;
  handleLoadClick?: () => void;
  onChangeSort?: (newColumnsData: ITableColumn<IAgreementRaw>[]) => void;
}

export const AgreementListTable = ({
  tableColumns,
  agreements,
  totalCount,
  setTableColumns,
  handleLoadClick,
  onChangeSort,
}: IAgreementListTableProps) => {
  const handleSortClick = useCallback(
    (id: keyof IAgreementRaw) => {
      const newColumnsData = handleSortChange(tableColumns, id);

      setTableColumns?.(newColumnsData);
      onChangeSort?.(newColumnsData);
    },
    [onChangeSort, setTableColumns, tableColumns],
  );

  return (
    <Fragment>
      <Table<IAgreementRaw>
        columns={tableColumns}
        data={agreements}
        onSortChange={handleSortClick}
        columnStyles={styles}
        headPlacement={undefined}
        checkedNames={['соглашение', 'соглашения', 'соглашений']}
        handleLoadClick={handleLoadClick}
        totalCount={totalCount}
      />
    </Fragment>
  );
};
